import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import './document.scss'
import Icon from "../icon/icon.component.jsx"

class Document extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            link: this.props.link || '',
            name: this.props.name || '',
            extension: this.props.extension || '',
            className: this.props.className || '',
            size: this.props.size || 'small',
            hideFileName: this.props.hideFileName
        }

        this.documentId = this.props.documentId
    }


    loadImage() {
        if (this.documentId) {
            AppContext.getApiClient().get('/files/' + this.documentId).then(res => {
                this.setState({
                    link: res.attributes.filePublicUrl,
                    name: this.state.hideFileName ? this.state.name : res.attributes.originalFileName,
                    extension: res.attributes.extension
                })
            })
        }
    }

    UNSAFE_componentWillMount() {
        this.loadImage()
    }

    render() {
        let icon = ''
        let extraClass = ''
        if (this.state.size === 'large') {
            extraClass = 'big-icon'
        }
        switch (this.state.extension) {
            case 'pdf':
                icon = <Icon value={"file-pdf"} className={"pdf-icon " + extraClass} />
                break
            case 'doc':
            case 'docx':
                icon = <Icon value={"file-word"} className={"doc-icon " + extraClass} />
                break
            case 'csv':
            case 'xls':
            case 'xlsx':
                icon = <Icon value={"file-excel"} className={"xls-icon " + extraClass} />
                break
            case 'ppt':
            case 'pptx':
                icon = <Icon value={"file-powerpoint"} className={"ppt-icon " + extraClass} />
                break
            case 'jpg':
            case 'jpeg':
            case 'png':
                icon = <Icon value={"file-image"} className={"doc-icon " + extraClass} />
                break
        }
        switch (this.state.size) {
            case 'large':
                return (
                    <a href={this.state.link} target="_blank" className={this.state.className}>
                        <p className="text-center p-0 m-0">{icon}</p>
                        <p className="text-center p-0 m-0">{this.state.name}</p>
                    </a>
                )
            default:
                return (
                    <a href={this.state.link} target="_blank" className={this.state.className}>
                        {icon}
                        &nbsp;
                        {this.state.name}
                    </a>
                )

        }
    }
}

export default Document





// WEBPACK FOOTER //
// ./src/common/document/document.component.jsx